export const SUPPORTS_OBJECT_SET_PROTOTYPE_OF = "setPrototypeOf" in Object;
